import PropTypes from 'prop-types';

const SqlServer = ({ width = '25px', height = '25px' }) => (
  <svg width={width} height={height} viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="17.5" cy="17.5" r="17.5" fill="#CC292B" />
    <path
      d="M10 11C10 9.62 13.35 8.5 17.5 8.5C21.65 8.5 25 9.62 25 11V24.5C25 25.88 21.65 27 17.5 27C13.35 27 10 25.88 10 24.5V11ZM10 11V12.5C10 13.88 13.35 15 17.5 15C21.65 15 25 13.88 25 12.5V11C25 12.38 21.65 13.5 17.5 13.5C13.35 13.5 10 12.38 10 11ZM10 15.5V17C10 18.38 13.35 19.5 17.5 19.5C21.65 19.5 25 18.38 25 17V15.5C25 16.88 21.65 18 17.5 18C13.35 18 10 16.88 10 15.5ZM10 20V21.5C10 22.88 13.35 24 17.5 24C21.65 24 25 22.88 25 21.5V20C25 21.38 21.65 22.5 17.5 22.5C13.35 22.5 10 21.38 10 20Z"
      fill="white"
      stroke="white"
      strokeWidth="0.5"
    />
  </svg>
);

SqlServer.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};

export default SqlServer;
